import { CheckCircle } from 'lucide-react'
import CheckoutLayout from '@/frontend/layouts/CheckoutLayout'
import { Card, CardContent } from '@/components/ui/card'

export default function PaymentLinkSuccess() {
  return (
    <CheckoutLayout>
      <div className="min-h-screen flex items-center justify-center px-4 py-28">
        <div className="w-full max-w-xl text-center">
          <div className="mb-6 flex justify-center">
            <div className="relative">
              <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/10 ring-1 ring-emerald-400/30">
                <CheckCircle className="h-11 w-11 text-emerald-400" />
              </div>
            </div>
          </div>

          <h1 className="text-3xl font-bold text-white">Pagamento recebido</h1>
          <p className="mt-3 text-base text-slate-300">
            Recebemos a confirmação do Stripe e estamos ativando a assinatura do colaborador digital.
          </p>

          <Card className="mt-8 border-slate-700 bg-slate-900/70">
            <CardContent className="p-5 text-sm text-slate-300">
              Você pode fechar esta página. A equipe da Station Zero acompanha a ativação pelo painel.
            </CardContent>
          </Card>
        </div>
      </div>
    </CheckoutLayout>
  )
}
